/**
 * Ids that should go through PUT affectedTask (not create/delete paths).
 */
export function filterUpdateIdsExcludingPending(
  affectedTaskIds: Array<string | number | null | undefined>,
  pendingCreateIds: Iterable<string | number>,
  pendingDeleteIds: Iterable<string | number>,
): string[] {
  const creates = new Set(
    [...pendingCreateIds].map((id) => String(id ?? '').trim()).filter(Boolean),
  );
  const deletes = new Set(
    [...pendingDeleteIds].map((id) => String(id ?? '').trim()).filter(Boolean),
  );
  const out: string[] = [];
  const seen = new Set<string>();
  for (const raw of affectedTaskIds) {
    const id = String(raw ?? '').trim();
    if (!id || creates.has(id) || deletes.has(id) || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}
